export default "__VITE_ASSET__BbooSKkS__"